import React, { useContext, useState } from "react";
import styled from "@emotion/styled";
import {
  Formik,
  useFormik,
  Form,
  Field,
  FieldArray,
  ErrorMessage,
} from "formik";
import { css } from "@emotion/react";
import * as yup from "yup";
import CircularProgress from "@mui/material/CircularProgress";
import CustomizedSnackbars from "../300/curriculum/CustomizedSnackbars";

import {
  FormGroup,
  TextField,
  InputLabel,
  MenuItem,
  InputAdornment,
  OutlinedInput,
  FormControl,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Box,
  Typography,
  FormControlLabel,
  FormLabel,
  Divider,
  Grid,
} from "@mui/material";
import { FormatLineSpacing } from "@mui/icons-material";
import { NavLink, useNavigate } from "react-router-dom";

import {
  col,
  formGroupContainer,
  groupStyled,
  header,
  labelStyled,
  leftCol,
  row,
} from "../../components/300/styles";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import CourseContext from "../../context/CourseContext";
import MUIDataTable from "mui-datatables";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import useAuth from "../../hooks/useAuth";
import EditIcon from "@mui/icons-material/Edit";

import { useEffect } from "react";
// Here the drop down menu

const validationSchema = yup.object({
  lecture_bsc_hourSetting: yup
    .number("Enter lecture hour for bsc")
    .test("Is positive?", "Please enter a positive value", (value) => value > 0)
    .required("lecture hour for bsc is required"),
  lab_bsc_hourSetting: yup
    .number("Enter lab hour for bsc")
    .required("lab hour for bsc is required")
    .test(
      "Is positive?",
      "Please enter a positive value",
      (value) => value > 0
    ),

  mentoring_bsc_hourSetting: yup
    .number("Enter mentoring hour for bsc")
    .required("mentoring hour for bsc is required")
    .test(
      "Is positive?",
      "Please enter a positive value",
      (value) => value > 0
    ),
  tutorial_bsc_hourSetting: yup
    .number("Enter tutorial hour for bsc")
    .required("tutorial hour for bsc is required")
    .test(
      "Is positive?",
      "Please enter a positive value",
      (value) => value > 0
    ),
  advisory_bsc_hourSetting: yup
    .number("Enter advisory hour for bsc")
    .required("advisory hour for bsc is required")
    .test(
      "Is positive?",
      "Please enter a positive value",
      (value) => value > 0
    ),
  lecture_msc_hourSetting: yup
    .number("Enter lecture hour for msc")
    .required("lecture hour for msc is required")
    .test(
      "Is positive?",
      "Please enter a positive value",
      (value) => value > 0
    ),

  lab_msc_hourSetting: yup
    .number("Enter lab hour for msc")
    .required("lab hour for msc is required")
    .test(
      "Is positive?",
      "Please enter a positive value",
      (value) => value > 0
    ),

  mentoring_msc_hourSetting: yup
    .number("Enter mentoring hour for msc")
    .required("mentoring hour for msc is required")
    .test(
      "Is positive?",
      "Please enter a positive value",
      (value) => value > 0
    ),
  tutorial_msc_hourSetting: yup
    .number("Enter tutorial hour for msc")
    .required("tutorial hour for msc is required")
    .test(
      "Is positive?",
      "Please enter a positive value",
      (value) => value > 0
    ),
  advisory_msc_hourSetting: yup
    .number("Enter advisory hour for msc")
    .required("advisory hour for msc is required")
    .test(
      "Is positive?",
      "Please enter a positive value",
      (value) => value > 0
    ),
  lecture_phd_hourSetting: yup
    .number("Enter lecture hour for phd")
    .required("lecture hour for phd is required")
    .test(
      "Is positive?",
      "Please enter a positive value",
      (value) => value > 0
    ),

  lab_phd_hourSetting: yup
    .number("Enter lab hour for phd")
    .required("lab hour for phd is required")
    .test(
      "Is positive?",
      "Please enter a positive value",
      (value) => value > 0
    ),

  mentoring_phd_hourSetting: yup
    .number("Enter mentoring hour for phd")
    .required("mentoring hour for phd is required")
    .test(
      "Is positive?",
      "Please enter a positive value",
      (value) => value > 0
    ),
  tutorial_phd_hourSetting: yup
    .number("Enter tutorial hour for phd")
    .required("tutorial hour for phd is required")
    .test(
      "Is positive?",
      "Please enter a positive value",
      (value) => value > 0
    ),
  advisory_phd_hourSetting: yup
    .number("Enter advisory hour for phd")
    .required("advisory hour for phd is required")
    .test(
      "Is positive?",
      "Please enter a positive value",
      (value) => value > 0
    ),
});
const muiCache = createCache({
  key: "mui",
  prepend: true,
});

function HourSetting() {
  const api = useAxiosPrivate();
  const navigate = useNavigate();
  const { user } = useAuth();

  const courseContext = useContext(CourseContext);

  const [open, setOpen] = useState(false);
  const [adding, setAdding] = useState(false);
  const [snackBarOpen, setSnackBarOpen] = useState(false);
  const [message, setMessage] = useState({
    message: "",
    type: "",
  });
  const [init, setInit] = useState({});

  return (
    <Formik
      initialValues={courseContext.hoursState}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        api
          .patch("/constant/updateHourSetting", values)
          .then((response) => {
            console.log(response);
            //alert(JSON.stringify(response, null, 2));
            setSnackBarOpen(true);
            setMessage({
              message: "Saved Successfully",
              type: "success",
            });
          })
          .catch((err) => {
            alert(JSON.stringify(err.response.data, null, 2));
            setSnackBarOpen(true);
            setMessage({
              message: err.response.data.message || "Error Occured",
              type: "error",
            });
          });
      }}
    >
      {({
        handleChange,
        values,
        setFieldValue,
        errors,
        touched,
        handleSubmit,
      }) => (
        <Form onSubmit={handleSubmit}>
          <Grid container spacing={3} sx={{ padding: "10px" }}>
            {/*<Grid item xs={12} md={6} lg={3} sx={{}}></Grid>*/}
            <Grid item xs={12} md={12} lg={12}>
              <Grid container spacing={3} marginBottom={2}>
                <Grid item xs={3} md={3} lg={3} sx={{ padding: "1rem" }}></Grid>
                <Grid item xs={3} md={3} lg={3} sx={{ padding: "1rem" }}>
                  Bsc
                </Grid>
                <Grid item xs={3} md={3} lg={3} sx={{ padding: "1rem" }}>
                  Msc
                </Grid>
                <Grid item xs={3} md={3} lg={3} sx={{ padding: "1rem" }}>
                  Phd
                </Grid>
              </Grid>
              <Grid container spacing={3} marginBottom={2}>
                <Grid item xs={3} md={3} lg={3}>
                  Lecture
                </Grid>
                <Grid item xs={3} md={3} lg={3}>
                  <TextField
                    id="lecture_bsc_hourSetting"
                    name="lecture_bsc_hourSetting"
                    value={values.lecture_bsc_hourSetting}
                    onChange={handleChange}
                    error={
                      errors.lecture_bsc_hourSetting &&
                      Boolean(errors.lecture_bsc_hourSetting)
                    }
                    helperText={
                      touched.lecture_bsc_hourSetting &&
                      errors.lecture_bsc_hourSetting
                    }
                    fullWidth
                    step="any"
                  />
                </Grid>
                <Grid item xs={3} md={3} lg={3}>
                  <TextField
                    id="lecture_msc_hourSetting"
                    name="lecture_msc_hourSetting"
                    value={values.lecture_msc_hourSetting}
                    onChange={handleChange}
                    error={
                      errors.lecture_msc_hourSetting && Boolean(errors.email)
                    }
                    helperText={
                      touched.lecture_msc_hourSetting &&
                      errors.lecture_msc_hourSetting
                    }
                    fullWidth
                  />
                </Grid>
                <Grid item xs={3} md={3} lg={3}>
                  <TextField
                    id="lecture_phd_hourSetting"
                    name="lecture_phd_hourSetting"
                    value={values.lecture_phd_hourSetting}
                    onChange={handleChange}
                    error={
                      errors.lecture_phd_hourSetting &&
                      Boolean(errors.lecture_phd_hourSetting)
                    }
                    helperText={
                      touched.lecture_phd_hourSetting &&
                      errors.lecture_phd_hourSetting
                    }
                    fullWidth
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3} marginBottom={2}>
                <Grid item xs={3} md={3} lg={3}>
                  Lab
                </Grid>
                <Grid item xs={3} md={3} lg={3}>
                  <TextField
                    id="lab_bsc_hourSetting"
                    name="lab_bsc_hourSetting"
                    value={values.lab_bsc_hourSetting}
                    onChange={handleChange}
                    error={
                      errors.lab_bsc_hourSetting &&
                      Boolean(errors.lab_bsc_hourSetting)
                    }
                    helperText={
                      touched.lab_bsc_hourSetting && errors.lab_bsc_hourSetting
                    }
                    fullWidth
                  />
                </Grid>
                <Grid item xs={3} md={3} lg={3}>
                  <TextField
                    id="lab_msc_hourSetting"
                    name="lab_msc_hourSetting"
                    value={values.lab_msc_hourSetting}
                    onChange={handleChange}
                    error={
                      errors.lab_msc_hourSetting &&
                      Boolean(errors.lab_msc_hourSetting)
                    }
                    helperText={
                      touched.lab_msc_hourSetting && errors.lab_msc_hourSetting
                    }
                    fullWidth
                  />
                </Grid>
                <Grid item xs={3} md={3} lg={3}>
                  <TextField
                    id="lab_phd_hourSetting"
                    name="lab_phd_hourSetting"
                    value={values.lab_phd_hourSetting}
                    onChange={handleChange}
                    error={
                      errors.lab_phd_hourSetting &&
                      Boolean(errors.lab_phd_hourSetting)
                    }
                    helperText={
                      touched.lab_phd_hourSetting && errors.lab_phd_hourSetting
                    }
                    fullWidth
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3} marginBottom={2}>
                <Grid item xs={3} md={3} lg={3}>
                  Tutorial
                </Grid>
                <Grid item xs={3} md={3} lg={3}>
                  <TextField
                    id="tutorial_bsc_hourSetting"
                    name="tutorial_bsc_hourSetting"
                    value={values.tutorial_bsc_hourSetting}
                    onChange={handleChange}
                    error={
                      errors.tutorial_bsc_hourSetting &&
                      Boolean(errors.tutorial_bsc_hourSetting)
                    }
                    helperText={
                      touched.tutorial_bsc_hourSetting &&
                      errors.tutorial_bsc_hourSetting
                    }
                    fullWidth
                  />
                </Grid>
                <Grid item xs={3} md={3} lg={3}>
                  <TextField
                    id="tutorial_msc_hourSetting"
                    name="tutorial_msc_hourSetting"
                    value={values.tutorial_msc_hourSetting}
                    onChange={handleChange}
                    error={
                      errors.tutorial_msc_hourSetting &&
                      Boolean(errors.tutorial_msc_hourSetting)
                    }
                    helperText={
                      touched.tutorial_msc_hourSetting &&
                      errors.tutorial_msc_hourSetting
                    }
                    fullWidth
                  />
                </Grid>
                <Grid item xs={3} md={3} lg={3}>
                  <TextField
                    id="tutorial_phd_hourSetting"
                    name="tutorial_phd_hourSetting"
                    value={values.tutorial_phd_hourSetting}
                    onChange={handleChange}
                    error={
                      errors.tutorial_phd_hourSetting &&
                      Boolean(errors.tutorial_phd_hourSetting)
                    }
                    helperText={
                      touched.tutorial_phd_hourSetting &&
                      errors.tutorial_phd_hourSetting
                    }
                    fullWidth
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3} marginBottom={2}>
                <Grid item xs={3} md={3} lg={3}>
                  Mentoring
                </Grid>
                <Grid item xs={3} md={3} lg={3}>
                  <TextField
                    id="mentoring_bsc_hourSetting"
                    name="mentoring_bsc_hourSetting"
                    value={values.mentoring_bsc_hourSetting}
                    onChange={handleChange}
                    error={
                      errors.mentoring_bsc_hourSetting &&
                      Boolean(errors.mentoring_bsc_hourSetting)
                    }
                    helperText={
                      touched.mentoring_bsc_hourSetting &&
                      errors.mentoring_bsc_hourSetting
                    }
                    fullWidth
                  />
                </Grid>
                <Grid item xs={3} md={3} lg={3}>
                  <TextField
                    id="mentoring_msc_hourSetting"
                    name="mentoring_msc_hourSetting"
                    value={values.mentoring_msc_hourSetting}
                    onChange={handleChange}
                    error={
                      errors.mentoring_msc_hourSetting &&
                      Boolean(errors.mentoring_msc_hourSetting)
                    }
                    helperText={
                      touched.mentoring_msc_hourSetting &&
                      errors.mentoring_msc_hourSetting
                    }
                    fullWidth
                  />
                </Grid>
                <Grid item xs={3} md={3} lg={3}>
                  <TextField
                    id="mentoring_phd_hourSetting"
                    name="mentoring_phd_hourSetting"
                    value={values.mentoring_phd_hourSetting}
                    onChange={handleChange}
                    error={
                      errors.mentoring_phd_hourSetting &&
                      Boolean(errors.mentoring_phd_hourSetting)
                    }
                    helperText={
                      touched.mentoring_phd_hourSetting &&
                      errors.mentoring_phd_hourSetting
                    }
                    fullWidth
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3} marginBottom={2}>
                <Grid item xs={3} md={3} lg={3}>
                  Advisory
                </Grid>
                <Grid item xs={3} md={3} lg={3}>
                  <TextField
                    id="advisory_bsc_hourSetting"
                    name="advisory_bsc_hourSetting"
                    value={values.advisory_bsc_hourSetting}
                    onChange={handleChange}
                    error={
                      errors.advisory_bsc_hourSetting &&
                      Boolean(errors.advisory_bsc_hourSetting)
                    }
                    helperText={
                      touched.advisory_bsc_hourSetting &&
                      errors.advisory_bsc_hourSetting
                    }
                    fullWidth
                  />
                </Grid>
                <Grid item xs={3} md={3} lg={3}>
                  <TextField
                    id="advisory_msc_hourSetting"
                    name="advisory_msc_hourSetting"
                    value={values.advisory_msc_hourSetting}
                    onChange={handleChange}
                    error={
                      errors.advisory_msc_hourSetting &&
                      Boolean(errors.advisory_msc_hourSetting)
                    }
                    helperText={
                      touched.advisory_msc_hourSetting &&
                      errors.advisory_msc_hourSetting
                    }
                    fullWidth
                  />
                </Grid>
                <Grid item xs={3} md={3} lg={3}>
                  <TextField
                    id="advisory_phd_hourSetting"
                    name="advisory_phd_hourSetting"
                    value={values.advisory_phd_hourSetting}
                    onChange={handleChange}
                    error={
                      errors.advisory_phd_hourSetting &&
                      Boolean(errors.advisory_phd_hourSetting)
                    }
                    helperText={
                      touched.advisory_phd_hourSetting &&
                      errors.advisory_phd_hourSetting
                    }
                    fullWidth
                  />
                </Grid>
              </Grid>
            </Grid>
            <Box
              sx={{
                display: "flex",
                gap: "1.6rem",
                justifyContent: "flex-end",
                width: "100%",
                padding: "20px 10px 10px 10px",
              }}
            >
              <CustomizedSnackbars
                {...{
                  setSnackBarOpen,
                  snackBarOpen,
                  message,
                  overlay: Boolean(message.type == "success"),
                }}
              />
              <Button
                variant="outlined"
                color="third"
                onClick={() => {
                  setModalState((prev) => {
                    return { open: false };
                  });
                }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "secondary.main",
                  "&:hover": {
                    backgroundColor: "secondary.hover",
                  },
                }}
                type="submit"
              >
                Save
              </Button>
            </Box>
          </Grid>
        </Form>
      )}
    </Formik>
  );
}

export default HourSetting;
